"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkExternal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * opens an external link in a new window
 */
var LinkExternal = function LinkExternal(_ref) {
  var children = _ref.children,
      cssClass = _ref.cssClass,
      url = _ref.url,
      atts = _ref.atts;

  var linkProps = _objectSpread({
    href: url,
    rel: 'noopener noreferrer',
    target: '_blank'
  }, atts);

  if (cssClass) {
    linkProps.className = cssClass;
  }

  return _react.default.createElement("a", linkProps, children);
};

exports.LinkExternal = LinkExternal;
LinkExternal.defaultProps = {
  atts: {},
  cssClass: ''
};
LinkExternal.propTypes = {
  atts: _propTypes.default.object,
  // optional additional html attributes
  cssClass: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  url: _propTypes.default.string.isRequired
};